module.exports = __webpack_public_path__ + "img/business_black_36dp.f29f9621.svg";